/** PURE_IMPORTS_START _isArray PURE_IMPORTS_END */
import { isArray } from './isArray';
export function isNumeric(val) {
    return !isArray(val) && (val - parseFloat(val) + 1) >= 0;
}
//# sourceMappingURL=isNumeric.js.map
